import React from 'react';
import { connect } from 'react-redux';
import { reportActions } from '../../../../actions/report.actions';
import DefaultUI from '../DefaultUI';

class AlarmHistory extends React.Component {
  constructor(props) {
    super(props);
  }
  onGetReport = (values) => {
    this.props.getAlarmHistory(
      values.format,
      values.sensorIds.join(','),
      values.fromDate,
      values.toDate,
    );
  };
  render() {
    return <DefaultUI onGetReport={this.onGetReport} />;
  }
}

function mapStateToProps(state) {
  return {
    report: state.report,
  };
}

export default connect(mapStateToProps, reportActions)(AlarmHistory);
